import uiRouter from 'angular-ui-router';
import teamCalendarComponent from './teamCalendar.component';
import managerYearInline from './managerYearInline/managerYearInline';
import { ROUTES } from 'common/domain/routes';
import { STATES } from 'common/domain/states';

let teamCalendarModule = angular.module('vacations-absences.teamCalendar', [
  uiRouter,
  managerYearInline,
])

  .config(($stateProvider) => {
    'ngInject';

    $stateProvider
      .state(STATES.VACATIONS_ABSENCES.TEAM_CALENDAR, {
        url: ROUTES.VACATIONS_ABSENCES.TEAM_CALENDAR,
        component: 'teamCalendar',
        data: {
          requiresAuth: true,
          requiresManager: true,
        },
        resolve: {
          /* @ngInject */
          isWageInProcess: (StatusAppCheckers) => StatusAppCheckers.isWageInProcess()
        }
      });
  })

  .component('teamCalendar', teamCalendarComponent)

  .name;

export default teamCalendarModule;



// WEBPACK FOOTER //
// ./client/app/vacations-absences.module/features/teamCalendar/teamCalendar.js